<div class="card detail">
  <div class="card-body">
    <div class="title text-left">
      <h3 class="card-title">{{ "Menu" | translate }}</h3>
      <small>{{ version }}</small>
    </div>
    <li
      *ngIf="permissions && permissions['read:any.user']"
      class="list-group-item"
    >
      <a routerLink="projects/create">
        <i class="icon-projects"></i>
        <p>{{ "Create New Project" | translate }}</p>
      </a>
    </li>
    <li class="list-group-item">
      <a routerLink="notifications" (click)="redirectToNotification()">
        <i class="icon-notification-bell"></i>
        <span
          *ngIf="notifications?.length > 0"
          class="badge badge-pill badge-danger"
          >{{ notifications?.length }}</span
        >
        <p>{{ "Notifications" | translate }}</p>
      </a>
    </li>
    <li class="list-group-item">
      <a (click)="redirectToProfile()">
        <i class="icon-social"></i>
        <p>{{ "Profile" | translate }}</p>
      </a>
    </li>
    <ul class="list-group overflow-visible">
      <li
        *ngIf="permissions && permissions['read:any.user']"
        class="list-group-item"
      >
        <a routerLink="users">
          <i class="icon-teams"></i>
          <p>{{ "Users" | translate }}</p>
        </a>
      </li>
      <li class="list-group-item lang-container">
        <a>
          <i class="icon-translate"></i>
          <p>{{ "Language" | translate }}</p>
        </a>
        <div class="card lang">
          <div class="card-body">
            <ul class="list-group">
              <li *ngIf="isSuperAdmin" class="list-group-item">
                <a (click)="openLangSettings()">
                  <i class="icon-settings"></i>
                  <p>{{ "Settings" | translate }}</p>
                </a>
              </li>
              <li class="list-group-item">
                <a (click)="useLanguage('en')">
                  <p>English</p>
                </a>
              </li>
              <li class="list-group-item">
                <a (click)="useLanguage('jp')">
                  <p>日本語</p>
                </a>
              </li>
              <li *ngIf="!isSuntory" class="list-group-item">
                <a (click)="useLanguage('de')">
                  <p>Deutsch</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li
        *ngIf="permissions && permissions['update:any.generictype']"
        class="list-group-item"
      >
        <a routerLink="dashboard">
          <i class="icon-settings"></i>
          <p>{{ "Generic Settings" | translate }}</p>
        </a>
      </li>
      <li class="list-group-item">
        <a (click)="logout()">
          <i class="icon-power"></i>
          <p>{{ "Log Out" | translate }}</p>
        </a>
      </li>
    </ul>
  </div>
</div>
